import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconNewChat = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.38408 6.20526C10.0222 4.33409 13.8309 4.49405 16.2537 6.56008L7.38408 6.20526ZM16.2537 6.56008C17.721 7.81234 18.3843 9.50579 18.254 11.1431C18.2146 11.6385 18.5843 12.0722 19.0798 12.1116C19.5753 12.151 20.0089 11.7813 20.0483 11.2858C20.2263 9.04939 19.3097 6.8018 17.4222 5.1909L17.4219 5.19071C14.3626 2.58158 9.64279 2.39632 6.34256 4.73719L6.34242 4.73729C3.1293 7.01729 2.17172 11.0614 4.10607 14.3275L3.1463 17.2069C3.04422 17.5131 3.11396 17.8505 3.32906 18.0912C3.54417 18.3319 3.87169 18.439 4.18741 18.3718L7.8528 17.5919C9.02809 18.1101 10.2999 18.3772 11.5867 18.3746C12.0837 18.3737 12.4859 17.9699 12.4849 17.4729C12.4839 16.9758 12.0802 16.5737 11.5831 16.5746C10.4633 16.5768 9.35759 16.3253 8.34899 15.8388C8.16927 15.7521 7.96584 15.7276 7.77068 15.7691L5.35134 16.2838L5.94866 14.4919C6.03714 14.2264 5.99713 13.9349 5.8404 13.7032C4.17616 11.2419 4.78582 8.04907 7.38394 6.20536"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3732 14.1231C18.3732 13.6261 17.9703 13.2231 17.4732 13.2231C16.9762 13.2231 16.5732 13.6261 16.5732 14.1231V15.7493H14.9479C14.4508 15.7493 14.0479 16.1522 14.0479 16.6493C14.0479 17.1463 14.4508 17.5493 14.9479 17.5493H16.5732V19.1758C16.5732 19.6728 16.9762 20.0758 17.4732 20.0758C17.9703 20.0758 18.3732 19.6728 18.3732 19.1758V17.5493H20.0004C20.4975 17.5493 20.9004 17.1463 20.9004 16.6493C20.9004 16.1522 20.4975 15.7493 20.0004 15.7493H18.3732V14.1231Z"
        />
      </svg>
    );
  }
);
